import { Injectable } from '@angular/core';
import {CrudService} from './crud.service';
import {Spring} from '../constants/spring';

@Injectable({
  providedIn: 'root'
})
export class PsadjterService {

  constructor(private crud: CrudService, private spring: Spring) { }

  getListPsadjterByIdtercer(idtercer: number) {
    return this.crud.get(`${this.spring.PSADJTER_GET_LIST_BY_IDTERCER}${idtercer}`);
  }
}
